import { render, staticRenderFns } from "./formAssessmentQuestionOption.vue?vue&type=template&id=61055b89"
import script from "./formAssessmentQuestionOption.vue?vue&type=script&lang=js"
export * from "./formAssessmentQuestionOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports